export default "__VITE_ASSET__Dzy6cUzM__"